import { render, staticRenderFns } from "./applicationGoods.vue?vue&type=template&id=63d34d90"
import script from "./applicationGoods.vue?vue&type=script&lang=js"
export * from "./applicationGoods.vue?vue&type=script&lang=js"
import style0 from "./applicationGoods.vue?vue&type=style&index=0&id=63d34d90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports